<template>
  <div class="group_rule" :class="{'isiOSX1':isiOSX}">
    <van-nav-bar
      :title="title"
      :fixed="true"
      left-arrow
      @click-left="goBack"
      :class="{'isiOSX':isiOSX}"
    />
    <div class="box">
      <div class="content" v-html="content">
      </div>
    </div>
    <van-button size="large" @click="next">好的，我已悉知</van-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isiOSX: false,
      title: '群政策解读',
      content: ''
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(this.$route.query.token);
    if(this.$route.query.type == 2) {
      this.title = '推广政策';
    }
    this.getContent();
  },
  mounted() {
    document.documentElement.style.setProperty('font-size', document.body.clientWidth / 375 * 10 + 'px');
  },
  methods: {
    goBack() {
      if(this.$route.query.from) {
        this.$router.go(-1);
      }else {
        this.params("", "", "goBack");
      }
    },
    next() {
      if(this.$route.query.from) {
        this.$router.go(-1);
        return;
      }
      if(this.$route.query.type == 1) {
        this.$router.push({
          path: "/xiaobaGroup/groupCode",
          query: {
            token: this.$route.query.token
          },
        });
      }else {
        this.$router.push({
          path: "/xiaobaGroup/merchantRegisterCode",
          query: {
            token: this.$route.query.token
          },
        });
      }
    },
    getContent() {
      this.$api
        .get("/member-relation/member/get/policy", {type: this.$route.query.type})
        .then(res => {
          this.content = this.$route.query.type == 1 ? res.group_policy : res.spread_policy;
        })
        .catch(err => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    }
  }
};
</script>
<style>
  html {
    font-size: 10px;
  }
</style>
<style lang="less" scoped>
.group_rule {
  height: 100%;
  box-sizing: border-box;
  background: #F5F6F7;
  padding-top: 72px;
  /deep/.van-nav-bar {
    height: 44px;
    line-height: 44px;
    padding-top: 28px;
    border: none;
    box-shadow: none;
    background: #fff;
    overflow: hidden;
    .van-nav-bar__title {
      color: #333 !important;
      font-size: 1.8rem;
      font-weight: 400;
    }
    .van-nav-bar__text {
      color: #333;
      font-size: 1.6rem;
      font-weight: 400;
      padding: 0 1.2rem;
    }
    .van-icon {
      color: #333;
    }
  }
  .isiOSX {
    padding-top: 44px;
  }
  .box {
    padding: 1.2rem 0 0;
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    .content {
      height: auto;
      background: #fff;
      padding: 1.2rem 1.2rem 10rem;
		  box-sizing: border-box;
      /deep/img {
        width: 100%;
      }
    }
  }
  .van-button {
    color: #F9591B;
    font-size: 1.6rem;
    height: 4.2rem;
    line-height: 4.2rem;
    text-align: center;
    width: 35.1rem;
    background: #fff;
    position: fixed;
    bottom: 4rem;
    left: 1.2rem;
    border-radius: 2.1rem;
    border: 1px solid #eee;
    font-weight: bold;
  }
}
.isiOSX1 {
  padding-top: 88px;
}
</style>


